import { FragmentOf } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { RichText } from "./RichText";
import { Options } from "@contentful/rich-text-react-renderer";
import { RichTextRenderOverrides } from "@hooks/useRichTextRenderOptions";
import { INLINES } from "@contentful/rich-text-types";
import { useFootnoteContext } from "@utils/FootnoteContext";

export const FootnoteRichText = ({
  content,
  options,
  overrides,
}: {
  content?: FragmentOf<typeof RichEntryFragment> | null;
  options?: Options;
  overrides?: RichTextRenderOverrides;
}) => {
  const { getNumber } = useFootnoteContext();

  const footnoteOptions: Options = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: (node) => {
        const id = node.data?.target?.sys?.id as string | undefined;
        if (!id) return null;
        const number = getNumber(id);
        if (number === null) return null;
        return <sup className="text-[0.7em] leading-none">{number}</sup>;
      },
      ...options?.renderNode,
    },
  };

  return <RichText content={content} options={footnoteOptions} overrides={overrides} />;
};
